import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import MapData from "./pages/MapData";
import UploadPDF from "./pages/UploadPDF";
import Shops from "./pages/Shops";
import Onboarding from "./pages/Onboarding";
import PasswordChange from "./pages/PasswordChange";
import RoadStatus from "./pages/RoadStatus";
import FishingForecast from "./pages/FishingForecast";
import HatchTracker from "./pages/HatchTracker";
import FishStocking from "./pages/FishStocking";
import StreamGauges from "./pages/StreamGauges";
import FishingRules from "./pages/FishingRules";
import HikingTrails from "./pages/HikingTrails";
import WaterRegulations from "./pages/WaterRegulations";
import CpwProperties from "./pages/CpwProperties";
import StateTrustLands from "./pages/StateTrustLands";
import StateParks from "./pages/StateParks";

export default class Main extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path='/admin' exact component={Home} />
          <Route path='/admin/map_data' component={MapData} />
          <Route path='/admin/upload_pdf' component={UploadPDF} />
          <Route path='/admin/accept_shops' component={Shops} />
          <Route path='/admin/onboarding_shops' component={Onboarding} />
          <Route path='/admin/road_status' component={RoadStatus} />
          <Route path='/admin/fishing_forecast' component={FishingForecast} />
          <Route path='/admin/hatch_tracker' component={HatchTracker} />
          <Route path='/admin/fish_stocking' component={FishStocking} />
          <Route path='/admin/fishing_rules' component={FishingRules} />
          <Route path='/admin/hiking_trails' component={HikingTrails} />
          <Route path='/admin/stream_gauges' component={StreamGauges} />
          <Route path='/admin/water_regulations' component={WaterRegulations} />
          <Route path='/admin/cpw_properties' component={CpwProperties} />
          <Route path='/admin/state_trust_lands' component={StateTrustLands} />
          <Route path='/admin/state_parks' component={StateParks} />
          <Route path='/admin/password' component={PasswordChange} />
        </Switch>
      </Router>
    );
  }
}
